import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminCampaigns from "./components/AdminCampaigns";

const AdminCampaign = () => {
    return (
        <SupportLayout userRole="ADMIN">
            <div className="pb-40">
                <div className="main_container_title_div mb-5 mt-10">
                    <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">
                        Recurring Campaigns
                    </h1>
                    <p className="text-gray-600 text-xl sm:text-base">
                        Manage automated recurring campaigns and track historical run statistics
                    </p>
                </div>

                <AdminCampaigns type="RECURRING" />
            </div>
        </SupportLayout>
    );
};

export default AdminCampaign;
